import PropTypes from 'prop-types'
import { forwardRef, memo } from 'react'

/**
 * The `SVGIcon`
 */
const SVGIcon = forwardRef((props, forwardedRef) => {
  const { uid, ...attributes } = props

  return (
    <svg ref={forwardedRef} viewBox="0 0 75.4895 47.9311" {...attributes}>
      <linearGradient id={uid} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" />
        <stop offset="100%" />
      </linearGradient>
      <g data-i>
        <path d="M0.8,44.8l35.4-10v13.6L0.8,44.8z M77.7,31.6l-37.3-9.1v-2c0-0.4,1-1.4,1.8-2.1c2.1-2,5.3-5,5.3-10.7 c0-7.1-4-11.3-10.8-11.3C31.5-3.6,25.9,0.1,25.9,7h5.3c0-1.8,0.6-3.2,1.9-4.1c1.2-0.9,2.7-1.2,3.6-1.2c3.8,0,5.5,1.9,5.5,6 c0,3.4-1.8,5-3.7,6.8c-1.6,1.5-3.5,3.3-3.5,6v2l-37.3,9.1c-0.4,0.1-0.7,0.5-0.7,0.9v6.8c0,0.6,0.6,1,1.1,0.9l37.9-10.1l1.3-0.4 c0.2,0,0.3,0,0.5,0l1.3,0.4l37.9,10.1c0.6,0.2,1.1-0.3,1.1-0.9v-6.8C78.3,32.1,78.1,31.7,77.7,31.6z M39.3,48.4l35.4-3.6l-35.4-10 V48.4z" />
      </g>
    </svg>
  )
})

// The display name
SVGIcon.displayName = 'SVGIcon'

/** @type {object} */
SVGIcon.propTypes = {
  uid: PropTypes.string.isRequired
}

// Memoize
export default memo(SVGIcon)
